import { cssVar } from '@chakra-ui/react';
const $arrowBg = cssVar('popper-arrow-bg');
const Tooltip = {
    baseStyle: {
        bg: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        boxShadow: '0px 4px 16px 4px rgba(0, 0, 0, 0.04)',
        color: 'black',
        display: 'inline-block',
        fontFamily: 'body',
        fontWeight: 'regular',
        padding: '8px',
        [$arrowBg.variable]: 'white',
    },
    defaultProps: {},
};
export default Tooltip;
